var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0749 9.52519L14.4749 2.9252C14.1749 2.6252 13.7249 2.6252 13.4249 2.9252L11.0249 5.32519C10.6499 5.70019 10.7999 6.1502 11.0249 6.3752L11.5499 6.9002L9.2999 9.15019C8.1749 8.92519 5.0999 8.40019 3.4499 10.0502C3.1499 10.3502 3.1499 10.8002 3.4499 11.1002L7.7249 15.3752L2.9999 20.1002C2.6999 20.4002 2.6999 20.8502 2.9999 21.1502C3.2999 21.4502 3.8249 21.3752 4.0499 21.1502L8.7749 16.4252L13.0499 20.7002C13.4999 21.0752 13.9499 20.9252 14.0999 20.7002C15.7499 19.0502 15.2249 15.9752 14.9999 14.8502L17.2499 12.6002L17.7749 13.1252C18.0749 13.4252 18.5249 13.4252 18.8249 13.1252L21.2249 10.7252C21.3749 10.2752 21.3749 9.82519 21.0749 9.52519ZM18.1499 11.4002L17.6249 10.8752C17.3249 10.5752 16.8749 10.5752 16.5749 10.8752L13.4999 14.0252C13.2749 14.2502 13.1999 14.4752 13.2749 14.7752C13.4999 15.6002 13.8749 17.6252 13.2749 18.9752L5.0249 10.7252C6.2999 10.1252 8.3999 10.5002 9.2249 10.7252C9.4499 10.8002 9.7499 10.7252 9.9749 10.5002L13.0499 7.42519C13.4999 6.97519 13.2749 6.6002 13.0499 6.3752L12.5249 5.8502L13.9499 4.5002L19.4999 10.0502L18.1499 11.4002Z",
    fill: "#0c3255"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 1.65694,
    height: 26.4514,
    rx: 0.828468,
    transform: "rotate(-45 2 3)",
    fill: "#0c3255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.9ceb93a044111cffe3381f334ee8ecb5.svg";
export { ForwardRef as ReactComponent };